export default __webpack_public_path__ + "static/media/webLogo.871844a7.png";